import { Box, Typography, IconButton, Chip, Avatar, alpha, useTheme } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const UserAnalyticsHeader = ({ user, orgId }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = {
    primary: theme.palette.primary.main,
    secondary: theme.palette.success.main,
    error: theme.palette.error.main,
    text: theme.palette.text.primary,
    textSecondary: theme.palette.text.secondary,
  };

  const initials = [user.first_name?.[0], user.last_name?.[0]].filter(Boolean).join('').toUpperCase() || '?';
  const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email;
  const isActive = user.is_active && user.is_allowed;

  return (
    <Box sx={{ mb: 3 }}>
      {/* Breadcrumb */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <IconButton onClick={() => navigate(`/admin/organizations/${orgId}`)} size="small">
          <ArrowLeft size={20} />
        </IconButton>
        <Typography
          variant="body2"
          sx={{ color: colors.textSecondary, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          onClick={() => navigate('/admin/organizations')}
        >
          Organizations
        </Typography>
        <Typography variant="body2" sx={{ color: colors.textSecondary }}>/</Typography>
        <Typography
          variant="body2"
          sx={{ color: colors.textSecondary, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          onClick={() => navigate(`/admin/organizations/${orgId}`)}
        >
          {user.organization_name || 'Organization'}
        </Typography>
        <Typography variant="body2" sx={{ color: colors.textSecondary }}>/</Typography>
        <Typography variant="body2" sx={{ fontWeight: 600, color: colors.text }}>{fullName}</Typography>
      </Box>

      {/* User Identity */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Avatar sx={{ width: 48, height: 48, bgcolor: alpha(colors.primary, 0.15), color: colors.primary, fontWeight: 600 }}>
          {initials}
        </Avatar>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: colors.text }}>{fullName}</Typography>
            <Chip
              label={isActive ? 'Active' : 'Inactive'}
              size="small"
              sx={{
                fontWeight: 600, fontSize: '0.7rem',
                bgcolor: isActive ? alpha(colors.secondary, 0.12) : alpha(colors.error, 0.12),
                color: isActive ? colors.secondary : colors.error,
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 0.5 }}>
            <Typography variant="body2" sx={{ color: colors.textSecondary }}>{user.email}</Typography>
            {(user.roles || []).map((r) => (
              <Chip key={r} label={r} size="small" variant="outlined" sx={{ fontSize: '0.65rem', height: 20 }} />
            ))}
            {user.created_at && (
              <Typography variant="caption" sx={{ color: colors.textSecondary }}>
                Member since {new Date(user.created_at).toLocaleDateString()}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UserAnalyticsHeader;
